export const getCiamAccessToken = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    const accessToken = window.CIAM.getAccessToken(window.MEDIAHUIS.config.auth0?.clientId ?? '')

    if (accessToken) resolve(accessToken)
    reject()
  })
}
